import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=4193f26e&scoped=true"
import script from "./Skeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./Skeleton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4193f26e",
  null
  
)

export default component.exports